import { LoaderAction, LoaderActionTypes, LoadingState } from '../types';

export const loading = (state: LoadingState = {}, action: LoaderActionTypes) => {
  const newState = { ...state };
  switch (action.type) {
    case LoaderAction.ADDING_TIME_LOADING:
      if (!newState[action.scope]) {
        newState[action.scope] = { count: 1, message: null };
      } else {
        newState[action.scope] = { count: newState[action.scope].count + 1, message: null };
      }
      return newState;
    case LoaderAction.SUB_TIME_LOADING:
      if (!newState[action.scope]) {
        newState[action.scope] = { count: 0, message: null };
      } else {
        newState[action.scope] = { ...newState[action.scope], count: Math.max(newState[action.scope].count - 1, 0) };
      }
      return newState;
    case LoaderAction.CHANGE_MESSAGE_LOADING: {
      newState[action.scope] = { count: 0, message: action.message };
      return newState;
    }
    default:
      return newState;
  }
};
